import * as React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { routes } from "../../appRoutingHelpers";
import { OrganizationKeyName } from "../../model/Organization";
import * as adminUserSelectors from "./adminUserSelectors";
import * as adminUserActions from "./adminUserActions";
import { RootState } from "../../store";
import Spinner, { SpinnerBlock } from "../common/Spinner";
import * as authSelectors from "../auth/authSelectors";
import { AdminUserListItem } from "../../service/api-response/AdminUsersSuccessResponse";
import { Dispatch } from "redux";
import { colors } from "../../components/colors";
import { StyledText } from "../../assets/typography/typography";
import { PrimaryButton } from "../../components/Buttons";
import { Table } from "../../components/table-components/Table";
import { TableRowHeader } from "../../components/table-components/TableRowHeader";
import { TableCellHeaderText } from "../../components/table-components/TableCellHeaderText";
import { AdminUserListRow } from "./AdminUserListRow";
import { AddAdminUserPopup } from "./AddAdminUserPopup";
import { AdminUsersMovingNotice } from "./AdminUsersMovingNotice";
import { heapsGoAdminAdminsUrl } from "./heapsgo-admin-links";

interface OwnProps {}
interface Props {
  isLoading: boolean;
  users: AdminUserListItem[];
  getAdminUsers: (org: OrganizationKeyName) => void;
  organization: OrganizationKeyName;
}

interface State {
  isAddAdminPopupVisible: boolean;
}

const mapStateToProps = (state: RootState, ownProps: OwnProps) => {
  const org = authSelectors.selectedOrganizationKeyName(state);
  return {
    organization: org,
    users: adminUserSelectors.adminUserList(state, org),
    isLoading: adminUserSelectors.isLoadingAdminUserList(state, org),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    getAdminUsers: (org: OrganizationKeyName) =>
      dispatch(adminUserActions.listAdminUsersAction(org)),
  };
};

class AdminUserList extends React.Component<Props, State> {
  state = {
    isAddAdminPopupVisible: false,
  };

  loadData() {
    this.props.getAdminUsers(this.props.organization);
  }

  componentDidMount() {
    this.loadData();
  }

  showAddAdminPopup = (e: React.MouseEvent<any>) => {
    e.preventDefault();
    this.setState({ isAddAdminPopupVisible: true });
  };

  render() {
    if (!this.props.users || this.props.isLoading) {
      return <SpinnerBlock />;
    }

    return (
      <div className="container mt-7">
        {this.state.isAddAdminPopupVisible && (
          <AddAdminUserPopup
            onClose={() => {
              this.setState({ isAddAdminPopupVisible: false });
            }}
          />
        )}
        <div className="mb-4">
          <AdminUsersMovingNotice
            href={heapsGoAdminAdminsUrl(this.props.organization)}
          />
        </div>
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header border-bottom-0 mt-4 mb-4 justify-content-between">
                <StyledText
                  color={colors.textPrimary}
                  className="bodyHeaderOneSemi card-title"
                >
                  Admin users
                </StyledText>
                <PrimaryButton
                  color={colors.white}
                  backgroundColor={colors.ctaMain}
                  hoverColor={colors.ctaSecondaryOne}
                  onClick={this.showAddAdminPopup}
                  type="button"
                >
                  New Admin User
                </PrimaryButton>
              </div>
              <div className="pl-5 pr-5">
                <Table>
                  <thead>
                    <TableRowHeader>
                      <TableCellHeaderText className="pl-3">
                        Name
                      </TableCellHeaderText>
                    </TableRowHeader>
                  </thead>
                  <tbody>
                    {this.props.users.map((u, i) => (
                      <AdminUserListRow
                        key={i}
                        href={routes.adminUserEdit(
                          this.props.organization,
                          u.id
                        )}
                        user={u}
                      />
                    ))}
                  </tbody>
                </Table>
              </div>
              <div className="card-footer text-center mr-5 ml-5 px-0">
                {this.props.isLoading && <Spinner />}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(AdminUserList));
